<template>
	<div class="save-pages">
		<div class="saved-form-section"> 
			<div class="form-section">
				<div class="from-header">
					<h2>{{ message }}</h2>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["message"],
	emits: ['updateAuthpopupComponent'],
	methods:{
		updatePopup(){
			this.$emit('updateAuthpopupComponent', false)
		},
	}
}
</script>
<style lang="scss" scoped>
$font-family: "Source Sans Pro",Arial,sans-serif;
.save-pages{
	padding: 0;
	font-family: $font-family;
	display: flex;
	flex-wrap: wrap;
	z-index: 99999;
	max-width: 992px;
	position: relative;
	margin:0px auto;
	border-radius: 5px;
	background: #fff;
	overflow: hidden;
	@media screen and (max-width:992px) {
		max-width: 500px;
		padding: 0 !important;
		
	}
	@media screen and (max-width:767px) {
		max-width: 410px;
		padding: 0 !important;
	}
	.saved-form-section{
		width:100%;
			.form-section{
				max-width: 410px;
				margin:0px auto !important;
				display: inline-block;
				vertical-align: middle;
				top: 50%;
				transform: translateY(-50%);
				width:100%;
				position: relative;
				.from-header{
					p{
						margin-bottom: 10px;
					}
				}
				h2{
					font-size: 18px;
					line-height: 28.8px;
					font-style: normal;
					font-weight: 700;
					color: #1B1B1B;
					text-align: center;
					@media(max-width:767px){
						padding: 0px 20px;
					}
				}
			}
	}
}
</style>